@import "@/ui/variables.css";

.badgeRoot {
  --color: var(--gray);

  display: inline-flex;
  align-items: center;
  gap: var(--space-1);

  border-radius: 3px;
  border: 1px solid;
  border-color: oklch(from var(--color) calc(l - 0.25) c h);
  background-color: oklch(from var(--color) calc(l + 0.15) calc(c - 0.07) h/0.8);
  color: oklch(from var(--color) calc(l - 0.4) c h);
  text-shadow: var(--inset-text-shadow);
  cursor: pointer;

  padding: 0.1rem var(--space-1);
  margin: var(--space-1) 0;

  font-size: 0.7rem;
  text-transform: uppercase;
  text-wrap: nowrap;

  &[data-color="yellow"] {
    --color: var(--yellow);
  }

  &[data-color="blue"] {
    --color: var(--blue);
  }

  &[data-color="oasis"] {
    --color: var(--oasis);
  }

  &[data-color="green"] {
    --color: var(--green);
  }

  &[data-color="red"] {
    --color: var(--red);
  }

  &[data-color="earthworm"] {
    --color: var(--earthworm);
  }

  &:hover {
    border-color: oklch(from var(--color) calc(l - 0.4) c h);
    background-color: oklch(from var(--color) l c h/0.4);
    color: oklch(from var(--color) calc(l - 0.3) c h);
  }
}
